export default __webpack_public_path__ + "static/media/eggward.474afe59.png";